import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, mapProps } from 'recompose'

import {TableCell} from 'react-toolbox/lib/table'

import {
  withViewProps,
  ViewTable,
} from 'components/custom/ModifyTable/index'

import styles from './styles.scss'

const tableHeadContent = {
  categoryLabel: (<TableCell key={0}>Test Category</TableCell>),
  name: (<TableCell key={1}>Test Name</TableCell>),
  details: (<TableCell key={2}>Details</TableCell>),
}


const withModelProps = mapProps(
  (props) => ({
    ...props,
    tableHeadContent
  })
)

const withStyle = CSSModules(styles)

const EnhancedViewTable = compose(
  withViewProps,
  withStyle
)(ViewTable)

export default compose(
  withModelProps
)(EnhancedViewTable)
